// extracted by mini-css-extract-plugin
export default {"host":"style_host__yyQv+","ndaBlock":"style_ndaBlock__Dt65Z"};